const IMAGE_PRE_FIX = '../images/';

export const getImgPath = (img: string) => `${IMAGE_PRE_FIX}${img}`;
